import { Dispatch, SetStateAction, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useApiCall from '../../../../../hooks/useApiCall';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { useQuery } from '../../../../../hooks/useQuery';
import ConsultsService from '../../../../../services/ConsultsService';
import MyModal from '../../../../Modal';
import { ICreateInstructionApiResponse, ListaItensVt, TrajetoInstruc } from '../types';

interface IRemoveInstructionModal {
  instructionToBeRemoved: TrajetoInstruc;
  removeInstructionModalShow: boolean;
  setRemoveInstructionModalShow: Dispatch<SetStateAction<boolean>>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  vtItensOptions: ListaItensVt[];
  setInstructions: Dispatch<SetStateAction<TrajetoInstruc[]>>;
}

export default function RemoveInstructionModal({
  instructionToBeRemoved,
  removeInstructionModalShow,
  setRemoveInstructionModalShow,
  vtItensOptions,
  setIsLoading,
  setInstructions,
}: IRemoveInstructionModal) {
  const { apiCall } = useApiCall();
  const { userCode, userProfile } = useGetGeneralAppData();
  const query = useQuery();
  const companyCode = query.get('codEmpresa');
  const { consultCode } = useParams();

  const removeInstruction = useCallback(async () => {
    const findCorrespondingVtItem = (vtItemCode: number) => (
      vtItensOptions.find((vt) => vt.codItem === vtItemCode)
    );

    const instructionToCodeLiteral: { [key: string]: number } = {
      'Transporte': 2,
      'Transporte Público': 2,
      'Caminhar': 1,
      'Caminhada': 1,
      'Abater Resultado': 3
    };

    await apiCall({
      apiToCall: ConsultsService.removeOrEditInstruction,
      reqBody: JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        tipoAcao: 2,
        codEmpresa: Number(companyCode),
        codConsulta: Number(consultCode),
        rota: instructionToBeRemoved.rota,
        codSentido: instructionToBeRemoved.codSentido,
        sequencia: instructionToBeRemoved.sequencia,
        trajetoInstrucoes: {
          tipoInstrucao: instructionToCodeLiteral[instructionToBeRemoved.instrucao],
          instrucao: instructionToBeRemoved.instrucao,
          sequencia: instructionToBeRemoved.sequencia,
          origem: instructionToBeRemoved.origem,
          destino: instructionToBeRemoved.destino,
          linhaTransporte: instructionToBeRemoved.linhaTransp,
          routeID: '',
          tempo: instructionToBeRemoved.tempo,
          distancia: instructionToBeRemoved.distancia,
          origemLat: instructionToBeRemoved.origemLat,
          origemLng: instructionToBeRemoved.origemLng,
          destinoLat: instructionToBeRemoved.destinoLng,
          destinoLng: instructionToBeRemoved.destinoLng,
          codGeo: findCorrespondingVtItem(instructionToBeRemoved.codItem)?.codGeo,
          codItem: instructionToBeRemoved.codItem,
          tarifa: findCorrespondingVtItem(instructionToBeRemoved.codItem)?.tarifa,
        }

      }),
      onStartLoad: () => setIsLoading(true),
      onEndLoad: () => setIsLoading(false),
      catchMessage: 'Não foi possível remover a instrução. Por favor, tente novamente',
      actionAfterResponse: (response: ICreateInstructionApiResponse) => {
        if (!response.codigo) {
          toast.error(`Não foi possível remover a instrução. Por favor, tente novamente (${response.msg})`);
          return;
        }
        setRemoveInstructionModalShow(false);
        toast.success('A instrução foi removida com sucesso. Conclua a roteirização, ou adicione mais instruções!');
        setInstructions(response.trajetoInstrucoes);
      }
    });
  }, [apiCall, companyCode, consultCode, instructionToBeRemoved.codItem, instructionToBeRemoved.codSentido, instructionToBeRemoved.destino, instructionToBeRemoved.destinoLng, instructionToBeRemoved.distancia, instructionToBeRemoved.instrucao, instructionToBeRemoved.linhaTransp, instructionToBeRemoved.origem, instructionToBeRemoved.origemLat, instructionToBeRemoved.origemLng, instructionToBeRemoved.rota, instructionToBeRemoved.sequencia, instructionToBeRemoved.tempo, setInstructions, setIsLoading, setRemoveInstructionModalShow, userCode, userProfile, vtItensOptions]);

  return (
    <MyModal
      show={removeInstructionModalShow}
      title="Remover Instrução"
      closeButtonLabel="Fechar"
      actionButtonLabel="Remover instrução"
      onClose={() => setRemoveInstructionModalShow(false)}
      onAction={() => removeInstruction()}
      // isActionButtonDisabled={!selectedItem.value}
      type="deleteAction"
      size='lg'
      modalBody={(
        <>
          Tem certeza que deseja remover essa instrução?
        </>
      )}
    />
  );
}
